import { render } from "./Settings.vue?vue&type=template&id=95b53fa4"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=95b53fa4&lang=css"
script.render = render

export default script